import React, { useState, useEffect } from 'react';
import Sidebar from '../mini-comp/Sidebar';
import Topbar from '../mini-comp/Topbar';
import axios from 'axios';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';

const Testimonials = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = Cookies.get('token');
        const response = await axios.get('https://inv.burrayhr.com/web/testimonials/', {
          headers: {
            'Content-Type': 'application/json',
          }
        });
        const responseData = response.data.results || response.data || [];
        setData(Array.isArray(responseData) ? responseData : []);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching testimonials:', error);
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const renderTableHeaders = () => {
    if (data.length === 0) return null;
    const keys = Object.keys(data[0]).filter(k => k !== 'id' && !k.endsWith('_id') && typeof data[0][k] !== 'object');
    return keys.map(key => (
      <th key={key} style={{ textTransform: 'capitalize' }}>{key.replace(/_/g, ' ')}</th>
    ));
  };

  const renderTableRows = () => {
    if (data.length === 0) return null;
    const keys = Object.keys(data[0]).filter(k => k !== 'id' && !k.endsWith('_id') && typeof data[0][k] !== 'object');
    return data.map((item, idx) => (
      <tr key={item.id || idx}>
        {keys.map(key => (
          <td key={key}>
            <div style={{ maxWidth: '300px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {String(item[key] !== null && item[key] !== undefined ? item[key] : 'N/A')}
            </div>
          </td>
        ))}
      </tr>
    ));
  };

  return (
    <div>
      <Topbar />
      <Sidebar />
      <div className="app-content-area">
        <div className="app-content-wrap">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-header justify-between align-items-center">
                    <h4 className="d-flex-items gap-10 m-0">Testimonials <span className="badge bg-label-primary">{data.length}</span></h4>
                    <button className="btn btn-primary-light btn-sm" onClick={() => navigate('/admin/website-analytics')}>Back to Analytics</button>
                  </div>
                  <div className="card-body pt-15">
                    <div className="table-responsive">
                      <table className="table text-nowrap w-100" id="dataTableDefault">
                        <thead>
                          <tr>
                            {renderTableHeaders()}
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            <tr><td colSpan="10" className="text-center py-4">Loading...</td></tr>
                          ) : data.length > 0 ? (
                            renderTableRows()
                          ) : (
                            <tr><td colSpan="10" className="text-center py-4">No testimonials found</td></tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
